import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=b00c27a8&scoped=true"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=b00c27a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00c27a8",
  null
  
)

export default component.exports